import script from "./CollapsibleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsibleCard.vue?vue&type=script&setup=true&lang=js"

import "./CollapsibleCard.vue?vue&type=style&index=0&id=ce6fff0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce6fff0a"]])

export default __exports__